import { Heading } from '@cinch-labs/design-system'
import React from 'react'
import { FeatureCard, FeatureCardProps } from '../feature-card'
import styles from './highlights-section.module.css'

export interface HighlightsSectionProps {
  title: string
  highlights: FeatureCardProps[]
}

export const HighlightsSection: React.FC<HighlightsSectionProps> = ({
  title,
  highlights,
}) => (
  <div className={styles.container}>
    {title && (
      <div className={styles.heading}>
        <Heading element="h2" className={styles.title}>
          {title}
        </Heading>
      </div>
    )}
    {highlights?.length > 0 && (
      <div className={styles.cardsWrapper}>
        {highlights.map((card: FeatureCardProps) => (
          <FeatureCard {...card} key={card.title} />
        ))}
      </div>
    )}
  </div>
)
